import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Supported languages
export const supportedLanguages = ['en', 'fr', 'ar'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

// Language display names
export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  fr: 'Français',
  ar: 'العربية',
};

// RTL languages
export const rtlLanguages: SupportedLanguage[] = ['ar'];

// Check if a language is RTL
export const isRtlLanguage = (lang: SupportedLanguage): boolean => {
  return rtlLanguages.includes(lang);
};

// Initialize i18next
i18n
  // Load translations from /public/locales
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Fallback language if detection fails or translation is missing
    fallbackLng: 'en',

    // Supported languages
    supportedLngs: supportedLanguages,

    // Debug mode for development only
    debug: process.env.NODE_ENV === 'development',

    // Namespace to use (default)
    defaultNS: 'translation',
    ns: ['translation'],

    // Interpolation options
    interpolation: {
      // React already escapes values to prevent XSS
      escapeValue: false,
    },

    // Language detection configuration
    detection: {
      // Order of detection methods (localStorage first, then browser navigator)
      order: ['localStorage', 'navigator'],
      // Key for localStorage
      lookupLocalStorage: 'language',
      // Cache user language selection
      caches: ['localStorage'],
    },

    // Backend configuration for loading translations
    backend: {
      // Path to translation files
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // React-specific options
    react: {
      // Wait for translations to be loaded before rendering
      useSuspense: true,
    },
  });

export default i18n;
